import React from "react";
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
} from "reactstrap";
import { Link } from "react-router-dom";
import "./style.css";
import LmsLogo from "../../Images/lmsLogo.png";

class NavBar extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
    };
  }

  toggle = () => {
    this.setState({
      isOpen: !this.state.isOpen,
    });
  };

  render() {
    const { onRouteChange, user } = this.props;
    return (
      <div className="navContainer">
        <Navbar
          className="homeNavBar animate__animated animate__fadeInDown"
          expand="md"
          dark
        >
          {" "}
          <NavbarToggler onClick={this.toggle} />
          <NavbarBrand target="_blank" href="https://www.w4work.com/home/">
            <img src={LmsLogo} alt="LmsLogo" width="25px" />
          </NavbarBrand>
          <Link to="/">
            {" "}
            <strong className="Navheader">Learn to Earn</strong>
          </Link>
          <Collapse isOpen={this.state.isOpen} navbar>
            <Nav navbar className="ml-auto">
              <Nav navbar>
                {user.usertype === "Admin" ? (
                  <Link to="/admin">
                    <NavItem>
                      <NavLink>
                        <p className="navBarText">Admin</p>
                      </NavLink>
                    </NavItem>
                  </Link>
                ) : null}

                <Link to="/">
                  <NavItem>
                    <NavLink>
                      <p className="navBarText">Home</p>
                    </NavLink>
                  </NavItem>
                </Link>

                <Link to="/courses">
                  <NavItem>
                    <NavLink>
                      <p className="navBarText">Courses</p>
                    </NavLink>
                  </NavItem>
                </Link>

                <Link to="/faqs">
                  <NavItem>
                    <NavLink>
                      <p className="navBarText">FAQs</p>
                    </NavLink>
                  </NavItem>
                </Link>

                <Link to="/trainer">
                  <NavItem>
                    <NavLink>
                      <p className="navBarText">Trainer</p>
                    </NavLink>
                  </NavItem>
                </Link>

                <Link to="/mission">
                  <NavItem>
                    <NavLink>
                      <p className="navBarText">CEO</p>
                    </NavLink>
                  </NavItem>
                </Link>

                <NavItem onClick={() => this.props.isSignedIn(false)}>
                  <NavLink>
                    <p className="navBarText">Logout</p>
                  </NavLink>
                </NavItem>
              </Nav>
            </Nav>
          </Collapse>
        </Navbar>
      </div>
    );
  }
}

export default NavBar;
